import GetSensorMeasurementsRequestModelBase from '../_generated/modelBases/get-sensor-measurements-request-model-base';

export default class GetSensorMeasurementsRequestModel extends GetSensorMeasurementsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
